const EventConstants = {
    STATUS: {
        Published: {
            id: 'Published',
            label: 'Published',
            index: 0,
        },
        Registration: {
            id: 'Registration',
            label: 'Registration in progress',
            index: 1,
        },
        Confirmation: {
            id: 'Confirmation',
            label: 'Confirm participation',
            index: 2,
        },
        InProgress: {
            id: 'InProgress',
            label: 'InProgress',
            index: 3,
        },
        Finished: {
            id: 'Finished',
            label: 'Finished',
            index: 4,
        },
    },
}

export default EventConstants
